import * as Signals from 'signals';
import * as ko from 'knockout';
import * as localisationHelper from "localisationHelper";

// Models
import { JoinConfiguration } from 'Content/ts/Models/Join/JoinConfiguration';
import { PriceBreakdownDetailsModel } from 'Content/ts//Models/Shared/PriceBreakdown/PriceBreakdownDetailsModel';
import { IMembershipPriceDetailsRequestModel } from 'Content/ts/Models/Join/Interfaces/IMembershipPriceDetailsRequestModel';

// Components
import 'Content/ts/Shared/PriceBreakdown/price-breakdown';

export interface PersonalDetailsParams {
    JoinConfig: JoinConfiguration;
}

export const Deps = {
    LocalisationHelper: localisationHelper,
};

export class PaymentDetails {
    customMessages: {
        CheckoutText: string;
    };

    priceDetails: PriceBreakdownDetailsModel;
    promoDiscount: KnockoutObservable<number>;
    promoCode: KnockoutObservable<string>;
    membershipStartDate: KnockoutObservable<string>;
    promoCodeEnabled: KnockoutObservable<boolean>;
    loadingPriceDetails: KnockoutObservable<boolean>;

    membershipPriceRequest: KnockoutObservable<IMembershipPriceDetailsRequestModel>;

    clearSignal: Signals.Signal;

    constructor(params: PersonalDetailsParams) {
        this.priceDetails = params.JoinConfig.priceDetails;
        this.promoDiscount = params.JoinConfig.promoDiscount;
        this.promoCode = params.JoinConfig.promoCode;
        this.loadingPriceDetails = params.JoinConfig.priceDetailsLoading;
        this.promoCodeEnabled = params.JoinConfig.promoCodeEnabled;
        this.membershipPriceRequest = params.JoinConfig.membershipPriceRequest;
        this.clearSignal = params.JoinConfig.agreementSelected;
        this.membershipStartDate = params.JoinConfig.membershipStartDateString;

        // Initialisation Methods
        this.retrieveCustomMessages();
    }

    private retrieveCustomMessages() {
        this.customMessages = {
            CheckoutText: Deps.LocalisationHelper.getString("JoinResources", "CheckoutText"),
        };
    };
}

var componentName = 'payment-details';
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: PaymentDetails,
    template: { require: `text!/Themes/Default/Content/ts/Join/${componentName}.html` }
});
